<template>
  <div>
    <h1>Deshabilitar conductor </h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Evidencia (adjuntar archivo .jpg, .png, .pdf)</label>
              <b-form-file
                v-model="$v.driver.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Evidencia"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Motivo de baja">
                <a-input ref="name" placeholder="Motivo de baja" v-model="$v.driver.reason.$model" />
                <small class="text-danger" v-if="!$v.driver.reason.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="$v.$invalid">
                  Deshabilitar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_DRIVER_BAN = gql`
  mutation createDriverBan($disabledBy: String, $reason: String, $driverId: Int, $fileUrl: String){
    createDriverBan(driverBan: { disabledBy: $disabledBy reason: $reason driverId: $driverId fileUrl: $fileUrl }){
      id
      enabledBy
    }
  }
`
const DELETE_DRIVER = gql`
  mutation deleteDriver($username: String){
    deleteDriver(username: $username) {
      message
    }
  }
`
const DISABLE_DRIVER = gql`
mutation disableDriver($id: Int){
  disableDriver(id: $id){
    message
    success
  }
}
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      driver: {
        file: null,
        reason: '',
      },
      fileState: null,
      disabledBy: this.$store.state.user.email,
      driverId: this.$route.params.id,
    }
  },
  methods: {
    onFileSelected(event) {
      this.driver.file = event.target.files[0]
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
    async handleSubmit() {
      this.$apollo.mutate({
        mutation: DISABLE_DRIVER,
        context: headers(),
        variables: {
          id: parseInt(this.driverId),
        },
      })
        .then(async({ data }) => {
          // console.log(data)
          if (!data.disableDriver.success) {
            this.makeToast(true, 'warning', 'Conductor en viaje', 'El conductor se encuentra en un viaje')
          } else {
            const file = []
            file.fileExtension = this.driver.file.name.split('.').pop()
            file.fileUploaded = this.driver.file
            console.log(file)
            // console.log(this.geofence.name)
            // this.disableForm()
            // console.log(this.$refs)
            const uploadedFile = await uploadFileS3(file)
            this.$apollo.mutate({
              mutation: DELETE_DRIVER,
              variables: {
                username: this.$route.params.cognitoUsername,
              },
              context: headers(),
            })
              .then(data => {
                // console.log(data)
                this.$apollo.mutate({
                  mutation: CREATE_DRIVER_BAN,
                  variables: {
                    disabledBy: this.disabledBy,
                    reason: this.driver.reason,
                    driverId: parseInt(this.driverId),
                    fileUrl: uploadedFile.Location,
                  },
                  context: headers(),
                })
                  .then(data => {
                    // console.log(data)
                    this.$router.push({ name: 'getDrivers' })
                  })
                  .catch(err => {
                    console.log('error1')
                    console.log(err)
                  })
              })
              .catch(error => {
                console.log('error2')
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log('error3')
          console.log(error)
        })
      /*
      const file = []
      file.fileExtension = this.driver.file.name.split('.').pop()
      file.fileUploaded = this.driver.file
      console.log(file)
      // console.log(this.geofence.name)
      // this.disableForm()
      // console.log(this.$refs)
      const uploadedFile = await uploadFileS3(file)
      this.$apollo.mutate({
        mutation: DELETE_DRIVER,
        variables: {
          username: this.$route.params.cognitoUsername,
        },
        context: headers(),
      })
        .then(data => {
          this.$apollo.mutate({
            mutation: CREATE_DRIVER_BAN,
            variables: {
              disabledBy: this.disabledBy,
              reason: this.driver.reason,
              driverId: parseInt(this.driverId),
              fileUrl: uploadedFile.Location,
            },
            context: headers(),
          })
            .then(data => {
              console.log(data)
              this.$router.push({ name: 'getDrivers' })
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(error => {
          console.log(error)
        }) */
      // console.log(uploadedFile)
    },
  },
  created() {
    console.log(this.$route.params)
  },
  validations: {
    driver: {
      file: { required },
      reason: { required },
    },
  },
}
</script>
